module.exports = __webpack_public_path__ + "img/document-add-outlined-symbol.620f96da.svg";